import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {PartnerUsersState} from './types';
import {getters} from './getters';
import {actions} from './actions';
import {mutations} from './mutations';

export const state: PartnerUsersState = {
  partnerUsers: [],
};

export const partnerUsers: Module<PartnerUsersState, RootState> = {
  state,
  getters,
  actions,
  mutations
};
